import { withCompController } from '@wix/editor-elements-integrations';
import {
  WTwitterFollowMapperProps,
  WTwitterFollowStateRefs,
  WTwitterFollowControllerProps,
} from '../WTwitterFollow.types';
import { mapConsentPolicyStateRefValues } from '../../ConsentPolicyWrapper/viewer/utils';

const compController = withCompController<
  WTwitterFollowMapperProps,
  WTwitterFollowControllerProps,
  never,
  WTwitterFollowStateRefs
>(({ stateValues, mapperProps }) => {
  return {
    ...mapperProps,
    currentUrl: stateValues.currentUrl,
    ...mapConsentPolicyStateRefValues(stateValues),
  };
});

export default compController;
